module.exports = __webpack_public_path__ + "static/media/PDF-06.09361522.webp";